import {isObject} from "@/lib/getVariableType";

export const initAssetStore = (state, dataType) => {
  if (!isObject(state.assets[dataType])) state.assets[dataType] = {}
}
